export default __webpack_public_path__ + "static/media/SEC1560.34I-39024_-23199_0.63db5a68.jpg";